import type { Autosave } from '@/lib/useAutosave'

/**
 * What just happened to the form, in one line: saving, saved (with a short-lived Undo), or a failure
 * the user can retry. Agents distrust a screen that saves silently, so the state is always stated
 * rather than implied by an absent button.
 */
export default function SaveState({ autosave, onRetry }: { autosave: Autosave; onRetry?: () => void }) {
  const { status, undo } = autosave
  if (!status) return null

  if (status === 'saving') {
    return <span className="text-xs text-gray-400 whitespace-nowrap">Saving…</span>
  }

  if (status === 'error') {
    return (
      <span className="text-xs text-danger flex items-center gap-1.5 whitespace-nowrap">
        Couldn’t save
        {onRetry && (
          <button type="button" onClick={onRetry} className="underline hover:no-underline">
            Retry
          </button>
        )}
      </span>
    )
  }

  return (
    <span className="text-xs text-gray-400 flex items-center gap-1.5 whitespace-nowrap">
      Saved ✓
      {undo && (
        <button type="button" onClick={undo} className="text-brand-primary hover:underline">
          Undo
        </button>
      )}
    </span>
  )
}
